import {
  FormControl,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import React from "react";

const initialValues = {
  administracao: "",
  entidades: "",
  esferas: "",
  localidades: "",
  tribunais: "",
};

const CnjFilter = ({ data, localidades, state, updateState }) => {
  const esferas = [
    { id: 1, nome: "Estadual", key: 1 },
    { id: 2, nome: "Federal", key: 2 },
    { id: 3, nome: "Municipal", key: 3 },
  ];

  const adm = [
    { id: 1, nome: "Direta", key: 1 },
    { id: 2, nome: "Indireta", key: 2 },
  ];

  let tribunais = [{ id: 1000, nome: "Limpar seleção", key: "limpar" }];
  Object.keys(data).map((k, i) => {
    if (k != "TJMMG") tribunais.push({ id: i, nome: k, key: i });
  });

  const SelectField = ({ form, field, label, options }) => {
    const handleBlur = () => field.onBlur(field.name, true);
    const handleChange = (e) => {
      const { value } = e.target;
      const { name } = field;

      let val = [];
      if (value != null || value != undefined) val = value;
      if (value == "Limpar seleção") val = "";

      updateState(name, val == "" ? [] : [val]);
      form.setFieldValue(name, val);
    };

    return (
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          {...field}
          id={field.name}
          onChange={handleChange}
          onBlur={handleBlur}
          input={<Input />}
        >
          {options.map((item, i) => (
            <MenuItem key={i} value={item.nome} id={item.id}>
              {item.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  return (
    <Paper elevation={4} style={{ marginBottom: "25px" }}>
      <Formik initialValues={initialValues}>
        {(props) => (
          <Form className="smart-form">
            <Grid container spacing={3} style={{ padding: "0px 10px" }}>
              <Grid item sm={12} md={4}>
                <Field
                  fullWidth
                  name="tribunais"
                  label="Tribunais"
                  options={tribunais}
                  component={SelectField}
                  onChange={props.handleChange}
                />
              </Grid>

              {/* {props.values.tribunais.length > 0 && <Grid item sm={12} md={4}>
                <Field
                  fullWidth
                  name="esferas"
                  label="Esferas"
                  options={esferas}
                  component={SelectField}
                />
              </Grid>}

              {props.values.tribunais.length > 0 && <Grid item sm={12} md={4}>
                <Field
                  fullWidth
                  name="localidades"
                  label="Localidades"
                  options={localidades}
                  component={SelectField}
                />
              </Grid>} */}
            </Grid>
          </Form>
        )}
      </Formik>
    </Paper>
  );
};

export default CnjFilter;
